import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { NominasEspeciales } from '../../../../models/nominasEspeciales';
import { NominasEspecialesService } from '../../../../services/nominas-especiales.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-nominas-especiales-list',
  templateUrl: './nominas-especiales-list.component.html',
  styleUrls: ['./nominas-especiales-list.component.css']
})
export class NominasEspecialesListComponent implements OnInit
{

  @Input() personalId: number;
  @Input() nominasEspeciales: NominasEspeciales[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<NominasEspeciales>();

  nominasEspecialesOri: NominasEspeciales[];
  nominasEspecialesGrupo: NominasEspeciales[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private nominasService: NominasEspecialesService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.nominasEspecialesOri = this.nominasEspeciales;
    this.inicializaFiltros();
    
    this.filtrarNominas();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarNominas()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.nominasEspeciales = this.nominasEspecialesOri.filter(i => Date.parse(i.fecha) <= hasta.getTime() && Date.parse(i.fecha) >= desde.getTime());    
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.nominasEspecialesGrupo == undefined)
      {
        this.nominasService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
            });
            
            this.nominasEspecialesGrupo = data;
            this.nominasEspeciales = this.nominasEspecialesGrupo;
          });

      } else
      {
        this.nominasEspeciales = this.nominasEspecialesGrupo;
      }
      
    } else
    {
      this.filtrarNominas();
    }
  }

  onChangeFiltros()
  {
    this.filtrarNominas();
  }

  visualizarDetalle(nomina)
  {
    this.VisualizarDetalle.emit(nomina);
  }

  add()
  {
    let nominaEspecial: NominasEspeciales = { id: 0, personal: this.personalId, cantidad: 0, importe: 0, moneda: 1, fecha: new Date().toString() };
    this.VisualizarDetalle.emit(nominaEspecial);
  }
}
